import type { Campaign, Client, UserAccessScope } from './types'

export function clientIsVisible(scope: UserAccessScope, clientId: string) {
  return scope.allClients || Boolean(scope.clients[clientId])
}

export function campaignIsVisible(scope: UserAccessScope, campaign: Pick<Campaign, 'clientId' | 'operation'>) {
  if (scope.allClients) return true
  const clientAccess = scope.clients[campaign.clientId]
  if (!clientAccess) return false
  if (!campaign.operation || clientAccess.allOperations) return true
  return clientAccess.operations.includes(campaign.operation)
}

export function clientForAccess(scope: UserAccessScope, client: Client): Client | undefined {
  if (scope.allClients) return client
  const clientAccess = scope.clients[client.id]
  if (!clientAccess) return undefined
  return {
    ...client,
    operations: clientAccess.allOperations
      ? client.operations
      : client.operations.filter(operation => clientAccess.operations.includes(operation)),
  }
}
